import React from 'react';
import { WysiwygField } from '../../../components';

import './style.scss';

const TextBlock = ({ entity }) => {
  const title = entity.getIn(['info', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');

  return (
    <div className="TextBlock">
      {title && <div className="TextBlock__title">{title}</div>}
      {body && (
        <WysiwygField
          property="schema:text"
          className="TextBlock__body"
          html={body}
        />
      )}
    </div>
  );
};

export default TextBlock;
